import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tag } from 'antd';
import { Enumify } from "enumify-ts";
import { CheckCircleOutlined, IssuesCloseOutlined, WarningOutlined } from "@ant-design/icons";
class PaymentApprovalStage extends Enumify() {
    description;
    colour;
    icon;
    static PENDING = new PaymentApprovalStage("Pending", "geekblue", () => {
        return (_jsx(IssuesCloseOutlined, {}));
    });
    static APPROVED = new PaymentApprovalStage("Approved", "green", () => {
        return (_jsx(CheckCircleOutlined, {}));
    });
    static REJECTED = new PaymentApprovalStage("Rejected", "volcano", () => {
        return (_jsx(WarningOutlined, {}));
    });
    static PAID = new PaymentApprovalStage("Finalised", "green", () => {
        return (_jsx(CheckCircleOutlined, {}));
    });
    static _ = PaymentApprovalStage._closeEnum();
    constructor(description, colour, icon) {
        super();
        this.description = description;
        this.colour = colour;
        this.icon = icon;
    }
    renderTag() {
        return _jsx(Tag, { icon: this.icon(), color: this.colour, children: this.description });
    }
    static filtersArray() {
        return PaymentApprovalStage.values.map(t => {
            return { text: t.description, value: t.key };
        });
    }
}
export default PaymentApprovalStage;
